import { useService } from '../common';
import { useCallback, useMemo } from 'react';
import { PaymentRequest } from './types';
import { ResponseStatus, ServiceResponse } from '../common/types';

const API = {
    PAYMENT_REQUEST: '/payment/request',
};

export const usePaymentService = () => {
    const service = useService();

    const createPaymentRequest = useCallback((requestBody: PaymentRequest): ServiceResponse => {
        return service.sendPostWithAuthorization(API.PAYMENT_REQUEST, requestBody)
            .then(service.handleResponse)
            .catch((error) => Promise.resolve({ status: ResponseStatus.ERROR, message:error.message }));
    }, [service]);

    return useMemo(() => ({
        createPaymentRequest,
    }), [createPaymentRequest]);
};